import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useFeatureFlagContext } from '@submodule/featureFlags';

import { useTenantSettings } from '../features/Settings/hooks';

import { triggerSilentRedirect } from './AuthContext';
import { hasUrlAccessToken } from './config';
import { useAuth } from './useAuth';

export const TenantAuthGuard: React.FC = () => {
  const { orgId } = useParams<{ orgId: string }>();
  const { isAuthenticated, isLoading } = useAuth();
  const { authorizationRequired } = useTenantSettings(orgId);
  const { resetApplicationContext, setApplicationContext } =
    useFeatureFlagContext();

  useEffect(() => {
    if (orgId) {
      setApplicationContext({
        isAnonymous: false,
        targetingKey: orgId,
        tenantId: orgId,
      });
    }
    return () => resetApplicationContext();
  }, [orgId, setApplicationContext, resetApplicationContext]);

  useEffect(() => {
    if (authorizationRequired && !isAuthenticated && !isLoading && !hasUrlAccessToken()) {
      triggerSilentRedirect();
    }
  }, [authorizationRequired, isAuthenticated, isLoading]);

  if (hasUrlAccessToken()) {
    return <Outlet />;
  }

  if (authorizationRequired === null) {
    return <div>Loading...</div>;
  }

  if (!authorizationRequired) {
    return <Outlet />;
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
};
